// "Trades hoje" = sum of today's status buckets from AdminDashboardResponse.
// Single source for the topbar metric cells; mirrors DashboardKpis.sumTrades
// (kept local there during the parallel skeleton/prefetch track — consolidate
// when that track lands).
import type { AdminDashboardSnapshot } from "../api";

/** Sum of today's trade buckets, or null when the snapshot has not loaded.
 *
 * Example: sumTodayTrades({ todayTrades: { pending: 1, win: 2, loss: 0,
 * cancelled: 1 }, ... }) → 4.
 */
export function sumTodayTrades(
  snapshot: AdminDashboardSnapshot | undefined,
): number | null {
  const buckets = snapshot?.todayTrades;
  if (!buckets) return null;
  return buckets.pending + buckets.win + buckets.loss + buckets.cancelled;
}
